import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { enumMarineInsuranceCommodity } from '@app/data-layer/enums/marine-insurance';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { MarineInsuranceManagementModel } from '@data-layer/models/marine-insurance';
import { DateTimezoneService } from '@services/date-timezone.service';

@Component({
  selector: 'app-marine-insurance-commodities-view-management-card',
  templateUrl: './marine-insurance-commodities-view-management-card.component.html',
  styleUrls: ['./marine-insurance-commodities-view-management-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceCommoditiesViewManagementCardComponent {
  @Input() public marineInsurance: MarineInsuranceManagementModel;
  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public DEFAULT_CURRENCY_CODE: typeof DEFAULT_CURRENCY_CODE = DEFAULT_CURRENCY_CODE;

  constructor(private dateTimeZoneService: DateTimezoneService) {}

  public get isVehiclesCommodity(): boolean {
    return this.marineInsurance?.insuredValue?.commodity?.id === enumMarineInsuranceCommodity.VEHICLES;
  }

  public get manufactureDate(): string {
    //Conversion of year string into full date string with year assuming we convert date to year only string upon saving
    const originalManufactureDate = this.marineInsurance?.updatedManufactureDate || this.marineInsurance?.manufactureDate;

    if (!originalManufactureDate) {
      return;
    }

    const newManufactureDate = this.dateTimeZoneService.formatInUserTZ(`${originalManufactureDate}-02-02`);
    return newManufactureDate;
  }
}
